import { InfrastructureEntitiesListEnum, YardEntityEnum } from '@search/graphql-typings';

import { mapToInformations, InfoModelRaw, InformationsEnum, TGenerateSeoUrlParams } from './infoHelpers/types/InfoModel';
import { getFitnessClub, getPark, getKindergarten, getShoppingMall, getGoodSchools, getSportsGround } from './infoHelpers';

export const buildInfoInfrastructure = (params: {
    buildB2cInfo?: boolean;
    isPluralForm?: boolean;
    generateUrl?: (params: TGenerateSeoUrlParams) => string;
    infrastructure: InfrastructureEntitiesListEnum[];
    yardEntityList: YardEntityEnum[];
}) => {
    const informationsRaw: InfoModelRaw[] = [
        {
            title: ' ',
            value: getGoodSchools(params.infrastructure, params.isPluralForm),
            key: InformationsEnum.goodSchools,
        },
        {
            title: ' ',
            value: getKindergarten(params.infrastructure),
            key: InformationsEnum.kindergarten,
        },
        {
            title: ' ',
            value: getPark(params.infrastructure),
            key: InformationsEnum.park
        },
        {
            title: ' ',
            value: getShoppingMall(params.infrastructure),
            key: InformationsEnum.shoppingMall
        },
        {
            title: ' ',
            value: getFitnessClub(params.infrastructure),
            key: InformationsEnum.fitnessClub
        },
        {
            title: ' ',
            value: getSportsGround(params.yardEntityList),
            key: InformationsEnum.sportsGround
        },
    ];

    return mapToInformations(informationsRaw, params);
};
